module.exports = __webpack_public_path__ + "static/media/29-7.9ae1dae1.mp3";